import { Box, styled } from "@mui/material";

const BoxContainer = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  padding: theme.spacing(2),
  minHeight: "100vh",
}));

export { BoxContainer };
